"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var React = __importStar(require("react"));
var context_1 = require("../context");
var models_1 = require("../../models");
/**
 * Utility hook to get the current Bootstrap breakpoint
 *
 * @remarks
 * These are sourced from a media query using standard Bootstrap pixel breakpoints.
 * Note: Since Breakpoint is a string enum, you cannot do comparisons directly
 * (eg. `current >= Breakpoint.MD` does not work);
 *
 * The utility hooks `useResponsive` and `useDeviceSize` will usually be most applicable
 * to your use case.
 *
 * @example
 * // To only render an element at XS breakpoint:
 * const currentBreakpoint = useBreakpoint();
 * return (currentBreakpoint === Breakpoint.XS) && element;
 */
var useBreakpoint = function () {
    var currentBreakpoint = React.useContext(context_1.WindowSizeContext).currentBreakpoint;
    return currentBreakpoint !== null && currentBreakpoint !== void 0 ? currentBreakpoint : models_1.Breakpoint.MD;
};
exports.useBreakpoint = useBreakpoint;
exports.default = exports.useBreakpoint;
